// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dvHv","left":"styles_left__1VIt-","desktopActions":"styles_desktopActions__2PLVL","title":"styles_title__Jo1N2"};